import { XRViewStatus, ControllerHandnessCodes } from '@g.frame/common.xr_manager';
import { FBX_MODEL, LoaderEventsName, TEXTURE } from '@g.frame/common.loaders';
import { ViewerModule } from '@g.frame/core';
import { ConeBufferGeometry, Group, Mesh, MeshBasicMaterial, MeshStandardMaterial, SphereGeometry, Vector3 } from 'three';
export default class QuestHandView extends ViewerModule {
    constructor(scene) {
        super();
        this.scene = scene;
        this._status = XRViewStatus.PREPARING;
    }
    getStatus() {
        return this._status;
    }
    prepareResources(loader) {
        this.loader = loader;
        this.loader.addResources([
            // {
            //     name: 'left_quest_hand',
            //     url: require('../assets/left_quest_hand_old.fbx'),
            //     type: FBX_MODEL
            // },
            // {
            //     name: 'right_quest_hand',
            //     url: require('../assets/left_quest_hand_old.fbx'),
            //     type: FBX_MODEL
            // },
            {
                name: 'left_quest_hand',
                url: require('../assets/left_quest_hand.fbx'),
                type: FBX_MODEL
            },
            {
                name: 'right_quest_hand',
                url: require('../assets/left_quest_hand.fbx'),
                type: FBX_MODEL
            },
            {
                name: 'left_bc',
                url: require('../assets/left_bc.png'),
                type: TEXTURE
            },
            {
                name: 'left_metallic',
                url: require('../assets/left_metallic.png'),
                type: TEXTURE
            },
            {
                name: 'left_normal_dx',
                url: require('../assets/left_normal_dx.png'),
                type: TEXTURE
            },
            {
                name: 'left_roughness',
                url: require('../assets/left_roughness.png'),
                type: TEXTURE
            },
        ]);
        this.loader.once(LoaderEventsName.loaded, () => this.init());
    }
    init() {
        this._status = XRViewStatus.READY;
        // const material = controller;
        this.controllerLeft = this.loader.getResource('left_quest_hand');
        this.controllerLeft.scale.set(0.01, 0.01, 0.01);
        this.controllerLeft.rotation.set(0, Math.PI, Math.PI / -2);
        this.controllerRight = this.loader.getResource('right_quest_hand');
        this.controllerRight.userData = {};
        this.controllerRight.rotation.set(0, Math.PI, Math.PI / 2);
        // this.controllerRight.material = this.controllerRight.children[0].children[0].material;
        this.controllerRight.scale.set(-0.01, 0.01, 0.01);
        [this.controllerLeft, this.controllerRight].forEach((el) => {
            // @ts-ignore
            el.children[0].children[0].material = new MeshStandardMaterial({
                color: '#ffffff',
                map: this.loader.getResource('left_bc'),
                roughnessMap: this.loader.getResource('left_roughness'),
                normalMap: this.loader.getResource('left_normal_dx'),
                metalnessMap: this.loader.getResource('left_metallic'),
            });
        });
        // Rays
        // this.controllerLightLeft = new GMesh<ConeBufferGeometry, MeshBasicMaterial>(new ConeBufferGeometry(0.003, 1.5, 16), new MeshBasicMaterial({color: 'blue'}));
        // this.controllerLightLeft.position.set(0.04, 0.05, .85);
        // this.controllerLightLeft.rotateX(Math.PI / 2);
        // this.controllerLightRight = new GMesh<ConeBufferGeometry, MeshBasicMaterial>(new ConeBufferGeometry(0.003, 1.5, 16), new MeshBasicMaterial({color: 'red'}));
        // this.controllerLightRight.position.set(-0.04, 0.05, .85);
        // this.controllerLightRight.rotateX(Math.PI / 2);
        this.controllerLeftWrapper = new Group();
        this.controllerLeftWrapper.name = 'Controller Left Wrapper';
        this.controllerLeftWrapper.add(this.controllerLeft);
        // this.controllerLeftWrapper.add(this.controllerLightLeft);
        this.controllerRightWrapper = new Group();
        this.controllerRightWrapper.name = 'Controller Right Wrapper';
        this.controllerRightWrapper.add(this.controllerRight);
        // this.controllerRightWrapper.add(this.controllerLightRight);
        // Fingers
        this.leftThumbFinger = this.controllerLeft.getObjectByName('handsb_l_thumb1');
        this.leftTriggerFinger = this.controllerLeft.getObjectByName('handsb_l_index1');
        this.leftSqueezeFingers = [this.controllerLeft.getObjectByName('handsb_l_pinky0'), this.controllerLeft.getObjectByName('handsb_l_ring1'), this.controllerLeft.getObjectByName('handsb_l_middle1')];
        this.controllerLeft.userData = {
            squeeze: this.leftSqueezeFingers,
            trigger: this.leftTriggerFinger,
            thumb: this.leftThumbFinger
        };
        this.rightThumbFinger = this.controllerRight.getObjectByName('handsb_l_thumb1');
        this.rightTriggerFinger = this.controllerRight.getObjectByName('handsb_l_index1');
        this.rightSqueezeFingers = [this.controllerRight.getObjectByName('handsb_l_pinky0'), this.controllerRight.getObjectByName('handsb_l_ring1'), this.controllerRight.getObjectByName('handsb_l_middle1')];
        this.controllerRight.userData = {
            squeeze: this.rightSqueezeFingers,
            trigger: this.rightTriggerFinger,
            thumb: this.rightThumbFinger
        };
        this.triggerFingersStartingRotations = [];
        this.leftTriggerFinger.traverse((obj) => {
            this.triggerFingersStartingRotations.push({
                name: obj.name,
                rotation: new Vector3().fromArray(obj.rotation.toArray())
            });
        });
        this.triggerFingersClosedRotations = [
            {
                name: 'handsb_l_index1',
                rotation: new Vector3(-1.65, -.25, -1.85)
            },
            {
                name: 'handsb_l_index2',
                rotation: new Vector3(0, 0, 1.85)
            },
            {
                name: 'handsb_l_index3',
                rotation: new Vector3(0, 0, 1.76)
            }
        ];
        this.triggerFingersPreClosedRotations = [
            {
                name: 'handsb_l_index1',
                rotation: new Vector3(-1.65, -.25, -2.62)
            },
            {
                name: 'handsb_l_index2',
                rotation: new Vector3(0, 0, .82)
            },
            {
                name: 'handsb_l_index3',
                rotation: new Vector3(0, 0, .61)
            }
        ];
        this.thumbFingersStartingRotations = [];
        this.leftThumbFinger.traverse((obj) => {
            this.thumbFingersStartingRotations.push({
                name: obj.name,
                rotation: new Vector3().fromArray(obj.rotation.toArray())
            });
        });
        this.thumbFingersClosedRotations = [
            {
                name: 'handsb_l_thumb1',
                rotation: new Vector3(2.96, -.52, 2.86)
            },
            {
                name: 'handsb_l_thumb2',
                rotation: new Vector3(0, 0, .53)
            },
            {
                name: 'handsb_l_thumb3',
                rotation: new Vector3(0, 0, 1.04)
            }
        ];
        this.squeezeFingersStartingRotations = [];
        this.leftSqueezeFingers.forEach(finger => finger.traverse((obj) => {
            this.squeezeFingersStartingRotations.push({
                name: obj.name,
                rotation: new Vector3().fromArray(obj.rotation.toArray())
            });
        }));
        this.squeezeFingersClosedRotations = [
            {
                name: 'handsb_l_middle1',
                rotation: new Vector3(-1.41, -.05, -1.8)
            },
            {
                name: 'handsb_l_middle2',
                rotation: new Vector3(0, 0, 1.75)
            },
            {
                name: 'handsb_l_middle3',
                rotation: new Vector3(0, 0, 2.2)
            },
            {
                name: 'handsb_l_ring1',
                rotation: new Vector3(-1.23, .13, -1.85)
            },
            {
                name: 'handsb_l_ring2',
                rotation: new Vector3(0, 0, 2)
            },
            {
                name: 'handsb_l_ring3',
                rotation: new Vector3(0, 0, 2)
            },
            {
                name: 'handsb_l_pinky0',
                rotation: new Vector3(-.98, .23, -0.2)
            },
            {
                name: 'handsb_l_pinky1',
                rotation: new Vector3(-.02, 0.04, -1.69)
            },
            {
                name: 'handsb_l_pinky2',
                rotation: new Vector3(0, 0, 1.87)
            },
            {
                name: 'handsb_l_pinky3',
                rotation: new Vector3(0, 0, 1.75)
            }
        ];
        this.squeezeFingersPreClosedRotations = [
            {
                name: 'handsb_l_middle1',
                rotation: new Vector3(-1.41, -.05, -2.62)
            },
            {
                name: 'handsb_l_middle2',
                rotation: new Vector3(0, 0, .86)
            },
            {
                name: 'handsb_l_middle3',
                rotation: new Vector3(0, 0, .75)
            },
            {
                name: 'handsb_l_ring1',
                rotation: new Vector3(-1.23, .13, -2.64)
            },
            {
                name: 'handsb_l_ring2',
                rotation: new Vector3(0, 0, .89)
            },
            {
                name: 'handsb_l_ring3',
                rotation: new Vector3(0, 0, .72)
            },
            {
                name: 'handsb_l_pinky0',
                rotation: new Vector3(-.98, .23, -0.11)
            },
            {
                name: 'handsb_l_pinky1',
                rotation: new Vector3(-.02, 0.04, -2.54)
            },
            {
                name: 'handsb_l_pinky2',
                rotation: new Vector3(0, 0, .79)
            },
            {
                name: 'handsb_l_pinky3',
                rotation: new Vector3(0, 0, .59)
            }
        ];
        this.controllerLeftWrapper.traverse(el => {
            el.raycast = () => {
            };
        });
        this.controllerRightWrapper.traverse(el => {
            el.raycast = () => {
            };
        });
        this.addObject(this.controllerLeftWrapper);
        this.addObject(this.controllerRightWrapper);
        let rayLeft, rayRight;
        // Left ray
        this.rayLeft = rayLeft = new Mesh(new ConeBufferGeometry(0.0025, 3.5, 16), new MeshBasicMaterial({ color: 'white' }));
        rayLeft.position.set(0, 0, -1.8);
        rayLeft.scale.set(1, 1, 1);
        rayLeft.rotation.set(-Math.PI / 2, 0, 0);
        this.addObject(rayLeft, null, this.controllerLeftWrapper);
        rayLeft.visible = false;
        // Right ray
        this.rayRight = rayRight = new Mesh(new ConeBufferGeometry(0.0025, 3.5, 16), new MeshBasicMaterial({ color: 'white' }));
        rayRight.position.set(0, 0, -1.8);
        rayRight.scale.set(1, 1, 1);
        rayRight.rotation.set(-Math.PI / 2, 0, 0);
        this.addObject(rayRight, null, this.controllerRightWrapper);
        this.fingerTip = new Mesh(new SphereGeometry(0.005), new MeshBasicMaterial({ color: 'green', visible: false }));
        this.addObject(this.fingerTip, null, this.controllerRightWrapper);
        this.fingerTip.position.set(0.0117, -0.015, -0.096);
    }
    updateView(viewModel) {
        const model = viewModel.model;
        // Left
        if (model.left.enabled) {
            this.controllerLeftWrapper.visible = true;
            this.visualUpdate(model.left, this.controllerLeft, this.controllerLeftWrapper);
        }
        // Right
        if (model.right.enabled) {
            this.controllerRightWrapper.visible = true;
            this.visualUpdate(model.right, this.controllerRight, this.controllerRightWrapper);
        }
    }
    visualUpdate(view, controller, wrapper) {
        // Model
        wrapper.position.copy(view.pose.position);
        wrapper.quaternion.copy(view.pose.orientation);
        // // Buttons
        // const stickLeft = controller.userData.stick;
        const trigger = controller.userData.trigger;
        if (view.trigger.pressed) {
            trigger.traverse((obj) => {
                this.triggerFingersClosedRotations.forEach((el) => {
                    if (el.name === obj.name) {
                        obj.rotation.setFromVector3(el.rotation);
                    }
                });
            });
            // } else if (view.trigger.touched) {
            //      trigger.traverse((obj) => {
            //          this.triggerFingersPreClosedRotations.forEach((el) => {
            //              if (el.name === obj.name) {
            //                  obj.rotation.setFromVector3(el.rotation);
            //              }
            //          });
            //      });
        }
        else if (view.trigger.value) {
            trigger.traverse((obj) => {
                this.triggerFingersClosedRotations.forEach((end) => {
                    if (end.name === obj.name) {
                        this.triggerFingersStartingRotations.forEach((start) => {
                            if (start.name === obj.name) {
                                obj.rotation.setFromVector3(start.rotation.clone().lerp(end.rotation.clone(), view.trigger.value));
                            }
                        });
                    }
                });
            });
        }
        else {
            trigger.traverse((obj) => {
                this.triggerFingersStartingRotations.forEach((el) => {
                    if (el.name === obj.name) {
                        obj.rotation.setFromVector3(el.rotation);
                    }
                });
            });
        }
        const squeeze = controller.userData.squeeze;
        if (view.squeeze.pressed) {
            squeeze.forEach(finger => finger.traverse((obj) => {
                this.squeezeFingersClosedRotations.forEach((el) => {
                    if (el.name === obj.name) {
                        obj.rotation.setFromVector3(el.rotation);
                    }
                });
            }));
            // } else if (view.squeeze.touched) {
            //     squeeze.forEach(finger => finger.traverse((obj) => {
            //         this.squeezeFingersPreClosedRotations.forEach((el) => {
            //             if (el.name === obj.name) {
            //                 obj.rotation.setFromVector3(el.rotation);
            //             }
            //         });
            //     }));
        }
        else if (view.squeeze.value) {
            squeeze.forEach(finger => finger.traverse((obj) => {
                this.squeezeFingersClosedRotations.forEach((end) => {
                    if (end.name === obj.name) {
                        this.squeezeFingersStartingRotations.forEach((start) => {
                            if (start.name === obj.name) {
                                obj.rotation.setFromVector3(start.rotation.clone().lerp(end.rotation.clone(), view.squeeze.value));
                            }
                        });
                    }
                });
            }));
        }
        else {
            squeeze.forEach(finger => finger.traverse((obj) => {
                this.squeezeFingersStartingRotations.forEach((el) => {
                    if (el.name === obj.name) {
                        obj.rotation.setFromVector3(el.rotation);
                    }
                });
            }));
        }
        const thumb = controller.userData.thumb;
        if (view.stick.touched || view.topBtn.touched || view.botBtn.touched) {
            thumb.traverse((obj) => {
                this.thumbFingersClosedRotations.forEach((el) => {
                    if (el.name === obj.name) {
                        obj.rotation.setFromVector3(el.rotation);
                    }
                });
            });
        }
        else {
            thumb.traverse((obj) => {
                this.thumbFingersStartingRotations.forEach((el) => {
                    if (el.name === obj.name) {
                        obj.rotation.setFromVector3(el.rotation);
                    }
                });
            });
        }
    }
    hideView(code) {
        if (code === ControllerHandnessCodes.LEFT && this.controllerLeftWrapper)
            this.controllerLeftWrapper.visible = false;
        if (code === ControllerHandnessCodes.RIGHT && this.controllerRightWrapper)
            this.controllerRightWrapper.visible = false;
    }
}
